import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

function UpdateAdvertisementModal({
  show,
  handleClose,
  adId,
  onUpdateSuccess,
}) {
  const [formData, setFormData] = useState({
    agencyName: "",
    adSize: "",
    location: "",
    startDate: "",
    endDate: "",
    amount: "",
    billNo: "",
  });
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchAdvertisementDetails = async () => {
      if (adId && show) {
        setLoading(true);
        try {
          const response = await axios.get(
            `${API_URL}get-advertisement.php?id=${adId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          if (response.data.success && response.data.data) {
            const ad = response.data.data;
            setFormData({
              agencyName: ad.agency || "",
              adSize: ad.ad_size || "",
              location: ad.location || "",
              startDate: ad.start_date || "",
              endDate: ad.end_date || "",
              amount: ad.amount || "",
              billNo: ad.bill_no || "",
            });
          } else {
            toast.error("Could not fetch advertisement details.");
            handleClose();
          }
        } catch (error) {
          toast.error("Failed to fetch advertisement details.");
          handleClose();
        } finally {
          setLoading(false);
        }
      }
    };
    fetchAdvertisementDetails();
  }, [adId, show, API_URL, token, handleClose]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const apiPayload = new FormData();
    apiPayload.append("id", adId);
    apiPayload.append("agency", formData.agencyName);
    apiPayload.append("ad_size", formData.adSize);
    apiPayload.append("location", formData.location);
    apiPayload.append("start_date", formData.startDate);
    apiPayload.append("end_date", formData.endDate);
    apiPayload.append("amount", formData.amount);
    apiPayload.append("bill_no", formData.billNo);

    try {
      const response = await axios.post(
        `${API_URL}update-advertisement.php`,
        apiPayload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.success) {
        toast.success("Advertisement updated successfully!");
        onUpdateSuccess();
        handleClose();
      } else {
        toast.error(response.data.message || "Failed to update advertisement.");
      }
    } catch (error) {
      toast.error("An error occurred while updating.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Advertisement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Agency Name</Form.Label>
                <Form.Control
                  type="text"
                  name="agencyName"
                  value={formData.agencyName}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label>Ad Size</Form.Label>
                <Form.Control
                  type="text"
                  name="adSize"
                  value={formData.adSize}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Location</Form.Label>
              <Form.Control
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  name="startDate"
                  value={formData.startDate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="endDate"
                  value={formData.endDate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Amount (₹)</Form.Label>
                <Form.Control
                  type="number"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label>Bill No</Form.Label>
                <Form.Control
                  type="text"
                  name="billNo"
                  value={formData.billNo}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Row>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default UpdateAdvertisementModal;
